<app-page-header [options]="options" (optionSelected)="optionSelected($event)"></app-page-header>
<div class="row" id="entireScreen">
  <div class="col-12">
    <app-storage-report-drives-table
      [storageReport]="storageReport"
      *ngIf="this.storageReport.status.name != ''"
      (drivesEvent)="receiveDrives($event)"
      [options]="options"
    ></app-storage-report-drives-table>
  </div>
</div>
